// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7f472b3f","27":"8d3b0f79","130":"8d5e96b1","223":"e0da86a9","252":"eb9bb36b","380":"5f028100","422":"b2c4934a","458":"f15bbeda","477":"7bd4e3bc","548":"9d66f6a7","570":"2af99416","711":"44f05487","791":"47924df2","926":"2f75b380","945":"82fa67a7","981":"06ebf490"}[chunkId] + ".chunk.js";
};